// extracted by mini-css-extract-plugin
module.exports = {"text_with-separator":"Typography_text_with-separator__rhQxz","text_with-separator_mobile":"Typography_text_with-separator_mobile__PmMhC"};